import {Link} from '@mui/material'
export const ExternalLink = props => <Link target='_blank' rel='noopener' {...props}>{props.children}</Link>